import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard, AdminGuard } from '@monorepo/ui/auth';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'career',
    loadChildren: () =>
      import('./modules/career/career.module').then(
        (m) => m.CareerContainerModule
      ),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./modules/content/about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./modules/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: 'terms-condition',
    loadChildren: () =>
      import('./modules/terms-condition/terms-condition.module').then(
        (m) => m.TermsConditionModule
      ),
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./modules/contact/contact.module').then((m) => m.ContactModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'listings',
    loadChildren: () =>
      import('./modules/listing/listing.module').then((m) => m.ListingModule),
  },
  {
    path: 'listing/:id',
    loadChildren: () =>
      import('./modules/location-details/location-details.module').then(
        (m) => m.LocationDetailsModule
      ),
  },
  {
    path: 'how-it-works',
    loadChildren: () =>
      import('./modules/content/how-it-works/how-it-works.module').then(
        (m) => m.HowItWorksModule
      ),
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./modules/checkout/checkout.module').then(
        (m) => m.CheckoutModule
      ),
  },
  {
    path: 'screen-manager',
    loadChildren: () =>
      import('./modules/screen-manager/screen-manager.module').then(
        (m) => m.ScreenManagerModule
      ),
  },
  {
    path: 'auth/email/action',
    loadChildren: () =>
      import('./modules/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule
      ),
  },
  {
    path: 'bookings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/booking/booking.module').then((m) => m.BookingModule),
  },
  {
    path: 'offers',
    loadChildren: () =>
      import('./modules/content/offers/offers.module').then(
        (m) => m.OffersModule
      ),
  },
  {
    path: 'campaigns',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/campaign/campaign.module').then(
        (m) => m.CampaignModule
      ),
  },
  {
    path: 'ads',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/advertisement/advertisement.module').then(
        (m) => m.AdvertisementModule
      ),
  },
  {
    path: 'ads/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/advertisement/advertisement.module').then(
        (m) => m.AdvertisementModule
      ),
  },
  {
    path: 'screens',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/screens/screens.module').then((m) => m.ScreensModule),
  },
  {
    path: 'finances',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/finances/finances.module').then(
        (m) => m.FinancesModule
      ),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('././modules/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
  },
  {
    path: 'support',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'admin',
    canActivate: [AdminGuard],
    loadChildren: () =>
      import('./modules/admin-panel/admin-panel.module').then(
        (m) => m.AdminPanelModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'responsible-hosting',
    loadChildren: () =>
      import(
        './modules/content/responsible-hosting/responsible-hosting.module'
      ).then((m) => m.ResponsibleHostingModule),
  },
  {
    path: 'signgaze-stories',
    loadChildren: () =>
      import('./modules/content/signgaze-stories/signgaze-stories.module').then(
        (m) => m.SigngazeStoriesModule
      ),
  },
  {
    path: 'accessibility',
    loadChildren: () =>
      import('./modules/content/accessibility/accessibility.module').then(
        (m) => m.AccessibilityModule
      ),
  },
  {
    path: 'invite',
    loadChildren: () =>
      import('./modules/content/invite/invite.module').then(
        (m) => m.InviteModule
      ),
  },
  {
    path: 'updates',
    loadChildren: () =>
      import('./modules/content/update/update.module').then(
        (m) => m.UpdateModule
      ),
  },
  {
    path: 'screen-support',
    loadChildren: () =>
      import('./modules/content/screen-support/screen-support.module').then(
        (m) => m.ScreenSupportModule
      ),
  },
  {
    path: 'trust',
    loadChildren: () =>
      import('./modules/content/trust-safety/trust-safety.module').then(
        (m) => m.TrustSafetyModule
      ),
  },
  {
    path: 'help',
    loadChildren: () =>
      import('./modules/help-articles/help-articles.module').then(
        (m) => m.HelpArticlesModule
      ),
  },
  {
    path: 'presence',
    loadChildren: () =>
      import('./modules/content/presence/presence.module').then(
        (m) => m.PresenceModule
      ),
  },
  {
    path: 'cancellation',
    loadChildren: () =>
      import('./modules/content/cancellation/cancellation.module').then(
        (m) => m.CancellationModule
      ),
  },
  {
    path: 'blogs',
    loadChildren: () =>
      import('./modules/blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./modules/not-found/not-found.module').then(
        (m) => m.NotFoundModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
